import Immutable from 'immutable';
import $ from 'jquery';
import { Panel } from './records';
import {
  analyticsTrackEvent,
  clampPanel,
  RowCount,
  activateSectionHeaderEdit,
  PANEL_VERSION,
  ROW_HEIGHT,
  PANEL_GAP,
  analyticsType,
  VIEW_EXISTING_REPORTS,
} from '../helpers';
import { randomId } from 'javascripts/utils';

// TODO: Clean this file up
export function hydrate(panels, meta) {
  return {
    type: 'HYDRATE',
    payload: {
      meta: Immutable.fromJS(meta),
      panels: Immutable.fromJS(panels).map(panelJSON => new Panel(panelJSON)),
    },
  };
}

export function setGridSize(e) {
  return {
    type: 'SET_GRID_SIZE',
    payload: {
      gridSize: parseInt(e.target.value) || '',
    },
  };
}

export function beginDrag(panelId) {
  return {
    type: 'BEGIN_DRAG',
    payload: { panelId },
  };
}

export function dropPanel(panelId, { columnOffset, rowOffset, dragType }) {
  return (dispatch, getState) => {
    const state = getState();

    const panels = state.get('panels');
    const panel = panels.get(panelId);

    let column = parseInt(panel.column);
    let row = parseInt(panel.row);
    let width = parseInt(panel.width);
    let height = parseInt(panel.height);

    if (dragType === 'move') {
      row = parseInt(panel.row) + rowOffset;
      column = parseInt(panel.column) + columnOffset;
    } else if (dragType === 'resize') {
      width = parseInt(panel.width) + columnOffset;
      height = parseInt(panel.height) + rowOffset;
    }

    ({ row, column, width, height } = clampPanel({
      row,
      column,
      width,
      height,
      rowCount: RowCount(panels, { includePadding: true }),
    }));

    dispatch({ type: 'DROP_PANEL', payload: {} });
    dispatch(
      updatePanel(
        panelId,
        Immutable.Map({
          configuration_row: row,
          configuration_column: column,
          configuration_width: width,
          configuration_height: height,
        })
      )
    );
  };
}

export function cancelPanelDrag() {
  return {
    type: 'DROP_PANEL',
    payload: {},
  };
}

export function openPanelModal(modal) {
  analyticsTrackEvent('User clicks add panel');
  return {
    type: 'OPEN_PANEL_MODAL',
    payload: {
      modal,
    },
  };
}

export function closePanelModal() {
  return {
    type: 'CLOSE_PANEL_MODAL',
    payload: {},
  };
}

export function addPanelFromExampleReport(report) {
  analyticsTrackEvent('User adds example panel', {
    reportType: report.id,
    panelType: report.title,
    source: 'Dashboard',
  });
  return (dispatch, getState) => {
    dispatch(
      addPanel({
        exampleReport: report.id,
        name: report.title,
      })
    );
  };
}

export function addPanelFromExistingReport(report) {
  analyticsTrackEvent('User adds existing report', {
    reportType: report.record_type,
    panelType: analyticsType(report, VIEW_EXISTING_REPORTS),
    source: 'Dashboard',
    'Report copied': report.useOriginal ? 'No' : 'Yes',
  });
  return (dispatch, getState) => {
    dispatch(
      addPanel({
        bookmarkId: report.id,
        name: report.name,
        useOriginal: report.useOriginal,
      })
    );
  };
}

export function addExtensionPanel(report) {
  return (dispatch, getState) => {
    dispatch(
      addPanel({
        extensionIdentifier: report.extensionIdentifier,
        exportName: report.exportName,
        name: report.name,
      })
    );
  };
}

export function addRichTextPanel() {
  return (dispatch, getState) => {
    dispatch(
      addPanel({
        bookmarkId: null,
        isRichText: true,
        name: 'Enter Rich text',
      })
    );
  };
}

export function addPanel(panelProps) {
  return (dispatch, getState) => {
    const state = getState();
    const row = RowCount(state.get('panels'));
    const panelSize = panelProps.isHeader
      ? { width: 12, height: 1 }
      : panelProps.isRichText
      ? { width: 5, height: 5 }
      : {
          width: 6,
          height: 5,
        };

    const panel = new Panel(
      Immutable.fromJS({
        id: randomId(),
        ...panelSize,
        column: 1,
        row,
        ...panelProps,
      })
    );

    dispatch(createPanel(panel.id, panel));
  };
}

export function createPanel(id, props) {
  return (dispatch, getState) => {
    const state = getState();
    const baseURL = state.getIn(['meta', 'baseURL']);
    const panelProps = props.toJS();
    panelProps.configuration_width = panelProps.width;
    panelProps.configuration_height = panelProps.height;
    panelProps.configuration_row = panelProps.row;
    panelProps.configuration_column = panelProps.column;
    panelProps.configuration_is_header = props.isHeader;
    panelProps.configuration_is_rich_text = props.isRichText;
    panelProps.configuration_version = PANEL_VERSION;

    delete panelProps.width;
    delete panelProps.height;
    delete panelProps.row;
    delete panelProps.column;
    delete panelProps.isHeader;
    delete panelProps.IsRichText;

    $.ajax({
      url: `${baseURL}/panel`,
      type: 'POST',
      dataType: 'json',
      data: {
        panel_id: id,
        panel_props: panelProps,
      },
      success: panel => {
        dispatch(closePanelModal());
        dispatch({
          type: 'UPDATE_PANEL',
          payload: {
            id,
            props: new Panel(Immutable.fromJS(panel)),
          },
        });
        if (
          ['Bookmarks::ReleaseProgress', 'ExtensionPanel'].includes(panel.type)
        ) {
          dispatch(openPanelModal(panel.id));
        } else if (panel.type === 'SectionHeaderPanel') {
          dispatch(scrollToRow(panel.row));
          activateSectionHeaderEdit(panel);
        }
      },
    });
  };
}
export function scrollToRow(row) {
  return (dispatch, getState) => {
    const gridParent = $('#Dashboard-Grid').parent();
    const rowHeight = ROW_HEIGHT + PANEL_GAP;
    gridParent.scrollTop(rowHeight * (row - 1));
  };
}

export function updatePanel(id, props) {
  return (dispatch, getState) => {
    const state = getState();
    const jsProps = props.toJS();
    jsProps.configuration_version = PANEL_VERSION;
    jsProps.configuration_bookmark_start_date = jsProps.bookmarkStartDate;
    jsProps.configuration_bookmark_end_date = jsProps.bookmarkEndDate;

    if (props.has('showLegend')) {
      jsProps.configuration_show_legend = props.get('showLegend');
    }

    if (props.has('dashboardFilter')) {
      jsProps.configuration_dashboard_filter = props.get('dashboardFilter');
    }

    if (props.has('release') && props.get('release')) {
      jsProps.configuration_release_id = props.get('release').get('id');
    }

    const baseURL = state.getIn(['meta', 'baseURL']);
    $.ajax({
      url: `${baseURL}/panel/${id}`,
      type: 'PUT',
      dataType: 'json',
      data: {
        panel_props: jsProps,
      },
      beforeSend: () => {
        // Only optimistically update what is needed
        const panelProps = {
          width: jsProps.configuration_width,
          height: jsProps.configuration_height,
          row: jsProps.configuration_row,
          column: jsProps.configuration_column,
          name: jsProps.name,
          dashboardFilter: jsProps.configuration_dashboard_filter,
          release: props.get('release'),
          showLegend: jsProps.configuration_show_legend,
          settings: jsProps.settings,
          bookmarkStartDate: jsProps.bookmarkStartDate,
          bookmarkEndDate: jsProps.bookmarkEndDate,
        };
        Object.keys(panelProps).forEach(k => {
          if (
            typeof panelProps[k] === 'undefined' ||
            (panelProps[k] === null &&
              !['bookmarkStartDate', 'bookmarkEndDate'].includes(k))
          ) {
            delete panelProps[k];
          }
        });

        dispatch({
          type: 'UPDATE_PANEL',
          payload: {
            id,
            props: panelProps,
          },
        });
      },
    })
      .done(() => {
        console.log('Panel updated successfully!');
      })
      .fail(() => {
        // Code to execute on failure
        console.log('Panel update failed!');
      });
  };
}

export function deletePanel(id) {
  return (dispatch, getState) => {
    const state = getState();
    const baseURL = state.getIn(['meta', 'baseURL']);

    $.ajax({
      url: `${baseURL}/panel/${id}`,
      type: 'DELETE',
      dataType: 'json',
    });

    dispatch({
      type: 'DELETE_PANEL',
      payload: {
        id,
      },
    });
  };
}

export function setReports(reports) {
  return {
    type: 'SET_REPORTS',
    payload: {
      data: reports,
    },
  };
}

export function selectReport(report) {
  return {
    type: 'SELECT_REPORT',
    payload: {
      data: report,
    },
  };
}
